import {
	IAdminAuthUserResponseData,
	IAuthConnectRequestPayload,
	IAuthConnectResponsePayload,
	ILoginRequestPayload,
	ITokenRequestPayload,
	ITokenResponsePayload,
	IAuthRefreshTokenRequestPayload,
} from 'redux/reducers/auth/types';
import { endpoint } from 'services/endpoint';
import { http, httpRefresh } from 'services/http';
import { TAuthApi } from './types';

// ==========================================:
export const auth: TAuthApi = {
	login: (payload) =>
		http
			.post<
				ILoginRequestPayload,
				{ data: IAdminAuthUserResponseData }
			>(endpoint.auth.LOGIN, payload)
			.then((response) => response.data),
	refreshToken: (payload) =>
		httpRefresh
			.post<
				IAuthRefreshTokenRequestPayload,
				{ data: ITokenResponsePayload }
			>(endpoint.auth.REFRESH_TOKEN, payload)
			.then((response) => response.data),

	logout: (payload) => http.post(endpoint.auth.LOGOUT, payload),
	tokenCode: (payload) =>
		http
			.post<
				ITokenRequestPayload,
				{ data: ITokenResponsePayload }
			>(endpoint.auth.TOKEN_CODE, payload)
			.then((response) => response.data),
	connect: (payload) =>
		http
			.post<
				IAuthConnectRequestPayload,
				{ data: IAuthConnectResponsePayload }
			>(endpoint.auth.CONNECT, payload)
			.then((response) => response.data),
	passwordPolicy: () =>
		http.get(endpoint.auth.PASSWORD_POLICY).then((response) => response.data.policy),
};
